module.exports = __webpack_public_path__ + "static/media/brasil_new_pastures-desktop.3275353e.jpg";